import { Database, Q } from '@nozbe/watermelondb'
import { Observable } from '@nozbe/watermelondb/utils/rx'
import { ComponentInfoChatVO, ComponentInfoLoadChatsVO } from '@repo/types'
import { Chat } from '..'
import { getChatListFiltersPredicate } from '../predicates'
import { getChatsUnreadsSum as _getChatsUnreadsSum } from '../readers'
import { map } from 'rxjs'
import {
  addChat as _addChat,
  addChatsInBatch as _addChatsInBatch,
  archiveChat as _archiveChat,
  deleteChats as _deleteChats
} from '../writers'

export class ChatRepository {
  database: Database

  constructor(database: Database) {
    this.database = database
  }

  async addChat(payload: ComponentInfoChatVO) {
    return _addChat(payload, this.database)
  }

  async addChatsInBatch(chats: ComponentInfoChatVO[]) {
    return _addChatsInBatch(chats, this.database)
  }

  async archiveChat(payload: ComponentInfoChatVO) {
    return _archiveChat(payload, this.database)
  }

  async deleteChats(openChatKey?: string) {
    return _deleteChats(this.database, openChatKey)
  }

  async getChatsUnreadsSum(filters: ComponentInfoLoadChatsVO) {
    return _getChatsUnreadsSum(this.database, filters)
  }

  getChatByChatId = async (id: string): Promise<Chat | undefined> => {
    const chatsCollection = this.database.collections.get<Chat>('chats')
    const chats = await chatsCollection.query(Q.where('id', Q.eq(id))).fetch()
    return chats?.[0]
  }

  observeChatsWithColumnLastMessageSortedByContactAt = (filters: ComponentInfoLoadChatsVO): Observable<Chat[]> => {
    const chats = this.database.collections.get<Chat>('chats')
    return chats
      .query(getChatListFiltersPredicate(filters), Q.sortBy('contact_at', Q.desc))
      .observeWithColumns(['last_message', 'unreads'])
      .pipe(
        map(chats => {
          const tagsTitles = filters.tags?.map(tag => tag.title) ?? []
          return chats.filter(chat => {
            return tagsTitles.length === 0 || (chat.tags ?? []).some(tag => tagsTitles.includes(tag.title))
          })
        })
      )
  }

  observeChatByChatId = (chatId: string): Observable<Chat> => {
    const chats = this.database.collections.get<Chat>('chats')
    return chats.findAndObserve(chatId)
  }
}
